import { Flex } from '@chakra-ui/react';
import { BaseToolbarButton } from '@cks-internal/react-base';
import { faUnlock, faUndo, faLock } from '@fortawesome/free-solid-svg-icons';
import { wfWigitModes } from '../../features/workflow/CoordinatorWidget';

export const ModeButtons = ({ mode, setMode }: { mode: wfWigitModes; setMode: (x: wfWigitModes) => void }) => {
  return (
    <Flex>
      <BaseToolbarButton
        icon={faUnlock}
        toggled={mode == wfWigitModes.Increment}
        onClick={() => {
          setMode(wfWigitModes.Increment);
        }}>
        Update Counts
      </BaseToolbarButton>
      <BaseToolbarButton
        icon={faUndo}
        toggled={mode == wfWigitModes.Decrement}
        onClick={() => {
          setMode(wfWigitModes.Decrement);
        }}>
        Undo Counts
      </BaseToolbarButton>
      <BaseToolbarButton
        icon={faLock}
        toggled={mode == wfWigitModes.Lock}
        onClick={() => {
          setMode(wfWigitModes.Lock);
        }}>
        Lock Counts
      </BaseToolbarButton>
    </Flex>
  );
};
